export default __webpack_public_path__ + "static/media/mode-21.7a4cb2a7.svg";